<div class="row mt-2 no-gutters">
  <div class="col">
    <small>
      <a *ngIf="accountCategory== 'RENTAL_FLEET'" [routerLink]="['/rental-fleet']" class="text-secondary">Admin Console
      </a>
      <a *ngIf="accountCategory== 'FLEET_MANAGEMENT_COMPANY' || accountCategory == 'MOBILITY_COMPANY' || accountCategory == 'FIELD_SERVICE_COMPANY'" [routerLink]="['/commercial-fleet']"
        class="text-secondary">Admin Console </a>
      <a *ngIf="accountType== 'VEHICLE_SERVICE_PROVIDER'" [routerLink]="['/service-provider/dashboard']"
        class="text-secondary">Admin Console </a>
      <a *ngIf="accountCategory== 'DEALER'" [routerLink]="['/dealer']"
        class="text-secondary">Admin Console </a>
      <a *ngIf="accountCategory== 'CORPORATE' || accountCategory == 'FINANCING_GROUP'" [routerLink]="['/corporate']"
        class="text-secondary">Admin Console </a>
      /<a [routerLink]="['/support']" class="text-secondary"> Support </a>
      /<a class="text-secondary">&nbsp;{{ticket.issueKey}}</a>
    </small>
  </div>
</div>

<div class="row pt-2 no-gutters">
  <div class="col-12">
    <span class="font16-700 text-muted">{{getRequestFieldValue('summary')}}</span>
  </div>
  <div class="col-md-4 col-sm-12 mt-2">
    <div class="float-none float-sm-left">
      <!-- <div><span class="font14-700">{{ticket.requestFieldValues[0].value}}</span></div> -->
      <div><span class="font14-700">Service Desk:&nbsp;</span><span class="font14-400">{{serviceDesk}}</span></div>
      <!-- <div class="mt-1">
        <label for="severity">Severity: </label>
        <select class="flat-dropdown" id="severity" [(ngModel)]="impact">
          <option [ngValue]="null">Severity</option>
          <option *ngFor="let severity of severities; let i = index;" [ngValue]="severity">
            {{severity}}
          </option>
        </select>
      </div> -->
    </div>
  </div>
  <div *ngIf="ticket.priority && ticket.priority.name" class="col-md-4 col-sm-12 mt-2">
    <div>
      <span class="font14-700">Priority:&nbsp;</span>
      <img class="height-16" [src]="ticket.priority.iconUrl" alt="">
      <span class="font14-400">{{ticket.priority.name}}</span>
    </div>
    <!-- <div *ngIf="ticket.status.toUpperCase() != 'CLOSED'">Assigned To:&nbsp;
      <select class="flat-dropdown" [(ngModel)]="assignedTo">
        <option [ngValue]="null">---Assignee---</option>
        <option *ngFor="let item of assigneeList; let i = index;" [ngValue]="item">
          {{item}}
        </option>
      </select>
    </div> -->
  </div>
  <div class="col-md-4 col-sm-12 mt-2">
    <div class="float-sm-none float-md-right">
      <div><span class="font14-700" [style.color]="statusColor">{{ticket.currentStatus.status}}</span></div>
      <div class="font14-400 mt-1" data-toggle="tooltip" data-placement="top"
        title="{{ticket.createdDate.iso8601 | date:'MM/dd/y h:mm:ss a'}}">
        {{ticket.createdDate.iso8601 | timeAgo}}</div>
    </div>
  </div>
</div>
<hr />
<div class="row no-gutters">
  <div class="col-sm-12 col-md-10 justify">
    <div><span class="font13-400">{{getRequestFieldValue('description')}}</span></div>
    <!-- <div *ngIf="requestAttachments.length > 0" class="font13-400 float-left mt-3">
        <i class="fa fa-paperclip text-muted" aria-hidden="true">Attachments</i>
        <div *ngFor="let attachment of requestAttachments;">
          <span class="link" (click)="downloadAttachment(attachment.content, attachment.mimeType, attachment.filename)">{{attachment.content}}</span>
        </div>
    </div> -->
  </div>
  <div class="col-sm text-center">
    <div class="float-right">
      <img class="ticket-img-7" src="assets/images/user_male.png"><br>
      <span class="font14-400">{{ticket.reporter.displayName}}</span>
    </div>
  </div>
</div>
<hr />
<div class="row no-gutters">
  <div class="col-sm-12">

    <div class="font14-400" *ngIf="ticket.currentStatus.statusCategory.toUpperCase() == 'CLOSED'">Assigned
      To:&nbsp;{{assignedTo}}</div>

    <label class="font14-400" for="ticketComment">Comment</label>
    <textarea rows="3" type="text" class="form-control" id="ticketComment" name="ticketComment" placeholder="Detail"
      required [(ngModel)]="comment" #ticketComment="ngModel"
      [disabled]="ticket.currentStatus.statusCategory.toUpperCase() == 'CLOSED'"></textarea>
  </div>
  <!-- <div class="col-sm-12 mt-4">
    <div class="custom-control custom-checkbox">
          <input type="checkbox" class="custom-control-input" id="isResolved">
          <label class="custom-control-label" for="isResolved">Please mark this ticket as Resolved</label>
      </div>
  </div> -->
  <div class="col-sm-12 mt-4">
    <div class="float-left">
      <i id="openFileUpload" (click)="addAttachmentInput.click()" class="fa fa-paperclip text-muted pointer mr-auto"
        aria-hidden="true" data-toggle="tooltip" title="File formats: .jpeg, .jpg, .png, .pdf, .txt, .json"></i>
      <span *ngIf="requestAttachment" class="text-muted font13-400 ml-2">{{requestAttachment.name}}</span>
      <input #addAttachmentInput class="hide import-light-btn" type="file"
        accept="image/jpeg,image/png,application/pdf,text/plain,.json"
        (change)="onAttachmentSelected($event.target.files)"><br>
      <span class="txt-small text-muted">(File formats: .jpeg, .jpg, .png, .pdf, .txt, .json)</span>
    </div>
    <div class="float-right">
      <button class="btn btn-light border btn-80"
        (click)="comment='';addAttachmentInput.value=null;requestAttachment=null;">Cancel</button>
      <button class="btn btn-primary border mr-2 btn-80" (click)="onSubmitComment()">Submit</button>
    </div>
  </div>
</div>
<hr />
<div class="row no-gutters" *ngFor="let item of comments;">
  <div class="col-2 text-center">
    <div><img class="ticket-img-4" src="assets/images/user_male.png"></div>
    <div><small class="font13-400">{{item.author.displayName}}</small></div>
  </div>
  <div class="col-8 justify">
		<div class="font13-400 mb-1" style="white-space: pre-line">{{getCommentText(item)}}</div>
    <div class="row" *ngIf="item.attachments && item.attachments.size > 0">
      <div class="col-lg-6 col-md-12" class="font11-400" *ngFor="let attachment of item.attachments.values;">
        <div class="attachment pointer" (click)="downloadAttachment(attachment._links.content, attachment.mimeType, attachment.filename)">
          <div class="row">
          <div class="col-2">
            <i [ngClass]="getAttachmentIcon(attachment.filename)"></i>
          </div>
          <div class="col">
            <div>{{attachment.filename}}</div>
            <div>{{getAttachmentSize(attachment.size)}}</div>
          </div>
        </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-2">
    <!-- Uncomment it to show only date-time for all comments-->
   <!-- <span class="font13-400 text-muted float-right">{{item.created.iso8601 | date:'MM/dd/y h:mm:ss a'}}</span>-->
   
    <span *ngIf="utilService.getDateDifference(item.created.epochMillis) < 8"
    class="float-right">{{item.created.iso8601 | timeAgo}}</span>
  <span *ngIf="utilService.getDateDifference(item.created.epochMillis) >= 8"
    class="float-right">{{item.created.iso8601 | date:'MM/dd/y h:mm:ss a'}}</span>
  </div>
</div><br>









<!-- <div class="row ml-3 mt-2">
  <div class="col">
    <small>
      <a *ngIf="accountCategory== 'RENTAL_FLEET'" [routerLink]="['/rental-fleet']" class="text-secondary">Admin Console </a>
      <a *ngIf="accountCategory== 'FLEET_MANAGEMENT_COMPANY'" [routerLink]="['/commercial-fleet']" class="text-secondary">Admin Console </a>
      /<a [routerLink]="['/support']" class="text-secondary"> Support </a>&nbsp;
      /<a class="text-secondary">&nbsp;Ticket Detail&nbsp;</a>
      /<a class="text-secondary">&nbsp;{{ticket.ticketNo}}</a>
    </small>
  </div>
</div>

<div class="row pt-2 ml-3 mr-3">
  <div class="col-12 mt-4">
    <h3 class="text-muted">Ticket Detail</h3>
  </div>
  <div class="col-md-4 col-sm-12">
    <div class="float-none float-sm-left">
      <div><b>{{ticket.subject}}</b></div>
      <div>Severity: </div>
      <div>
        <select [(ngModel)]="impact">
          <option [ngValue]="null">Severity</option>
          <option *ngFor="let severity of severities; let i = index;" [ngValue]="severity">
            {{severity}}
          </option>
        </select>
      </div>
    </div>
  </div>
  <div class="col-md-4 col-sm-12">
    <div><b>Service Desk:</b>&nbsp;{{ticket.serviceDesk}}</div>
  </div>
  <div class="col-md-4 col-sm-12">
    <div class="float-sm-none float-md-right">
      <div><b>{{ticket.status}}</b></div>
      <div data-toggle="tooltip" data-placement="top" title="{{ticket.date | date:'MM/dd/y h:mm:ss a'}}">
        {{ticket.date | timeAgo}}</div>
    </div>
  </div>
</div>
<hr />
<div class="row ml-3 mr-3">
  <div class="col-sm-12 col-md-10" style="text-align: justify;">
    <span>{{ticket.comment}}</span>
  </div>
  <div class="col-sm text-center">
    <img class="ticket-img" src="assets/images/user_male.png"><br>
    <span>{{ticket.raisedBy}}</span>
  </div>
</div>
<hr />
<div class="row ml-3 mr-3">
  <div class="col-sm-12">

    <div *ngIf="ticket.status.toUpperCase() == 'CLOSED'">Assigned To:&nbsp;{{assignedTo}}</div>
    <div class="mt-4">Comment</div>
    <textarea rows="5" type="text" class="form-control" id="ticketComment" name="ticketComment" placeholder="Detail"
      required [(ngModel)]="comment" #ticketComment="ngModel"></textarea>
  </div>
  <div class="col-sm-12 mt-4">
  </div>
  <div class="col-sm-12 mt-4 text-center">
    <button class="btn btn-primary border" (click)="onSubmitComment()">Submit</button>
  </div>
</div>
<hr />
<div class="row ml-3 mr-3" *ngFor="let item of comments;">
  <div class="col-sm-1 col-2 text-center">
    <div><img class="ticket-img-4" src="assets/images/user_male.png"></div>
    <div><small>{{item.user.name}}</small></div>
  </div>
  <div class="col-sm-8 col">
    <div style="text-align: justify;">{{item.comment}}</div>
    <div class="float-right"><small class="text-muted">{{item.timestamp | date:'MM/dd/y h:mm:ss a'}}</small></div>
    <hr style="margin-top: 30px;" />
  </div>
</div> -->